import { Action } from '@/_core/fluxstore/types';
import { CurrentUserState } from '../types';
import { useCurrentUserModule } from '../useModule';

const { registerReducer } = useCurrentUserModule();

export class UpdateCurrentUser extends Action<CurrentUserState> {
    public static ACTION_TYPE = 'UpdateCurrentUser';
    public constructor(public name: string, public loginName: string) {
        super(UpdateCurrentUser.ACTION_TYPE);
    }
}

const reducer = (state: CurrentUserState, action: UpdateCurrentUser): void => {
    state.fullName = action.name;
    state.loginName = action.loginName;
};

//@ts-ignore
registerReducer(UpdateCurrentUser.ACTION_TYPE, reducer);
